import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "none",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.357 7.182h12.186V5.605H6.78l1.577 1.577Zm-4.472-.16v.16h.16l-.16-.16Zm15.354 11.042c1.837-.208 2.975-.496 2.975-.816V9.436h-1.666V8.394H9.569l9.67 9.67ZM5.258 8.394H3.88v1.042H2.214v7.813c0 .633 4.477 1.145 10 1.145 1.042 0 2.047-.018 2.992-.052L5.258 8.394Z" fill="#CECECE"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M2.544 4.558a.788.788 0 0 1 1.115 0l15.34 15.34a.788.788 0 1 1-1.114 1.116L2.544 5.673a.788.788 0 0 1 0-1.115Z" fill="#BD3D3A"/>' }
  })
);